import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import moment from 'moment';

import { useTranslation } from 'react-i18next';
import { isNil, omitBy } from 'lodash';
import { fetchFunnelSteps, exportFunnel as exportFunnelAction } from '../../actions/funnels';
import RightModalLayout from '../layouts/Modal/RightModalLayout';
import { SIDEBAR_ACTIONS } from '../../constants/actionsConstants';
import { DEFAULT_FUNNELS_FILTERS } from '../../constants/funnels';
import FunnelFilterFields from '../modules/Funnels/FunnelFilterFields';

const FunnelFilter = ({ selectedFunnel, variant = 'funnels_search', orderBy, orderDirection }) => {
  const dispatch = useDispatch();
  const { searchFunnelsParams } = useSelector((reduxState) => reduxState.funnelsReducer);
  const [defaultFilters, setDefaultFilters] = useState({ ...searchFunnelsParams });

  const isExportation = variant === 'csv_export';

  const { t } = useTranslation('Funnels');

  const handleSubmitFilters = (e) => {
    e.preventDefault();
    const filters = {
      ...defaultFilters,
      start_created_at: defaultFilters.start_created_at ? moment(defaultFilters.start_created_at).format('YYYY-MM-DD') : '',
      end_created_at: defaultFilters.end_created_at ? moment(defaultFilters.end_created_at).format('YYYY-MM-DD') : '',
      start_expected_close_date: defaultFilters.start_expected_close_date ? moment(defaultFilters.start_expected_close_date).format('YYYY-MM-DD') : '',
      end_expected_close_date: defaultFilters.end_expected_close_date ? moment(defaultFilters.end_expected_close_date).format('YYYY-MM-DD') : '',
      included_tags: defaultFilters.included_tags ? defaultFilters.included_tags : [],
      agents: defaultFilters.agents ? defaultFilters.agents : [],
      searchText: searchFunnelsParams.searchText,
      order_by: orderBy === 0 ? 'created_at' : 'updated_at',
      order_direction: orderDirection
    };

    const filtersNotNil = omitBy(filters, isNil);

    if (variant === 'funnels_search') {
      dispatch({ type: "SET_FUNNEL_SEARCH_FILTER", filters });
      dispatch(fetchFunnelSteps(filtersNotNil, selectedFunnel.web_id));
    } else {
      // TODO: Agregar apertura de modal de Academy
      dispatch(exportFunnelAction(filtersNotNil));
    }

    closeModal();
  };

  const handleClearFilters = () => {
    setDefaultFilters(DEFAULT_FUNNELS_FILTERS);
    if (variant === 'funnels_search') {
      dispatch({ type: "CLEAR_FUNNEL_SEARCH_FILTER" });
    }
  };

  const closeModal = () => {
    dispatch({ type: SIDEBAR_ACTIONS.CLOSE_SIDEBAR });
  };

  useEffect(() => {
    if (isExportation && selectedFunnel.web_id) {
      setDefaultFilters((oldFilters) => ({
        ...oldFilters,
        funnels: [selectedFunnel.web_id]
      }));
    }
  }, [selectedFunnel, isExportation]);

  return (
    <RightModalLayout
      title={t(`filters.title.${variant}`)}
      submitAction={handleSubmitFilters}
      cancelAction={handleClearFilters}
      submitLabel={t(`filters.buttons.${variant}`)}
      cancelLabel={t('filters.cancel')}
      footerVariant="VERTICAL"
      footerClassName="tw-border-none"
    >
      <FunnelFilterFields
        filters={defaultFilters}
        setFilters={setDefaultFilters}
        showExportFields={isExportation}
      />
    </RightModalLayout>
  );
};

export default FunnelFilter;
